export default {
  methods: {
    fitBounds(coordinates, distantZoom = false) {
      this.$refs.map.$mapPromise.then(map => {
        var bounds = new this.google.maps.LatLngBounds()
        for (var i = 0; i < coordinates.length; i++) {
          bounds.extend(coordinates[i])
        }
        if (distantZoom) {
          map.fitBounds(bounds)
          map.setZoom(16)
        } else {
          map.fitBounds(bounds)
        }
      })
    }
  }
}
